import React from 'react'
import { useFormContext } from 'react-hook-form'

import { onboardingJson as onboardingProcessDataSrc } from './onboarding-process.js'
import styles from './OnboardingQuestion.module.css'

const SubTitleByStepID = (props) => {
  const { subtitle, currentStepId, reasonForUsingBot } = props

  if (currentStepId !== 3) {
    return <label className={styles.QuestionSubLabel}>{subtitle}</label>
  }

  const customSubtitle = `${subtitle}`.replace('<%= s %>', reasonForUsingBot?.trackOf || '')

  return <label className={styles.QuestionSubLabel}>{customSubtitle}</label>
}

const QuestionByStepID = (props) => {
  // props
  const { reasonForUsingBot, currentStepId } = props

  const id = reasonForUsingBot && reasonForUsingBot.id
  let qText

  if (currentStepId === 2) {
    if (id === 1) {
      qText = (
        <label>
          Great. Now choose one or more goals for your <span className={styles.HightlightText}> Support </span> bot.
        </label>
      )
    } else if (id === 2) {
      qText = (
        <label>
          Great. Now choose one or more goals for your <span className={styles.HightlightText}> Sales </span> bot.
        </label>
      )
    } else if (id === 3) {
      qText = (
        <label>
          Great. Now choose one or more goals for your <span className={styles.HightlightText}> E-Commerce </span> bot.
        </label>
      )
    } else {
      qText = <label>We think these might be good starting points for you!</label>
    }
  } else if (currentStepId === 3) {
    if (id === 1) {
      qText = <label>Finally, how many tickets do you currently get per month?</label>
    } else if (id === 2) {
      qText = <label>Finally, how many leads do you currently get per month?</label>
    } else if (id === 3) {
      qText = <label>Finally, how many orders do you currently get per month?</label>
    } else {
      return null
    }
  }
  return qText || null
}

const OnboardingQuestion = () => {
  const { watch } = useFormContext()

  const currentStepId = watch('currentStepId')
  const reasonForUsingBot = watch('reasonForUsingBot')
  const subtitle = onboardingProcessDataSrc.question[`step${currentStepId}`].subtitle

  return (
    <div className={styles.QuestionLabelContent}>
      <label className={styles.QuestionLabel}>
        {currentStepId === 1 && 'I want to use HappyFox Chatbot to…'}
        {currentStepId !== 1 && (
          <QuestionByStepID currentStepId={currentStepId} reasonForUsingBot={reasonForUsingBot} />
        )}
      </label>
      <label className={styles.QuestionSubLabel}>
        <SubTitleByStepID subtitle={subtitle} currentStepId={currentStepId} reasonForUsingBot={reasonForUsingBot} />
      </label>
    </div>
  )
}

export default OnboardingQuestion
